import { render, staticRenderFns } from "./GoodsEdit.vue?vue&type=template&id=7bb08e02&scoped=true"
import script from "./GoodsEdit.vue?vue&type=script&lang=js"
export * from "./GoodsEdit.vue?vue&type=script&lang=js"
import style0 from "./GoodsEdit.vue?vue&type=style&index=0&id=7bb08e02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb08e02",
  null
  
)

export default component.exports